export default "__VITE_ASSET__3058ad05__"